import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 4E574535-954C-42F5-BE5B-DF3716DB7C5A
 * name alert-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const AlertOutlineIcon = createSvgIcon(<><path d="M12,2L1,21H23M12,6L19.53,19H4.47M11,10V14H13V10M11,16V18H13V16" /></>, 'AlertOutlineIcon');
export default AlertOutlineIcon